
<template>
  <!-- 搜案例 -->
  <div class="background_box">
    <div class="box">
      <div class="case">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0 10px 0;margin:0 0 0 42px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="case01" @click="toCase" style="font-weight: 700">搜案例</span></el-breadcrumb-item>
          <el-breadcrumb-item>高级检索</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="advanced_search">
          <div style="">
            <el-form ref="form" :model="form" label-width="120px" :inline="true" style="width: 1000px"
              class="advancedDown">
            <!-- <el-form-item label="关键词检索">
                <div v-for="(item, index) in form.keyWord" :key="index">
                  <div>
                    <el-select
                      v-if="index > 0"
                      class="sel"
                      style="width: 80px; margin: 0 0px 10px 0"
                      v-model="item.ties"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="word_s">
                    <el-select
                      class="sel"
                      style="width: 80px; margin: 0 10px 0 0"
                      v-model="item.tit"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options_tit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-model="item.word"
                      placeholder="请输入关键词"
                      clearable
                      style="width: calc(100% - 300px)"
                    ></el-input>

                    <el-button
                      :disabled="form.keyWord.length >= 3"
                      :style="
                        form.keyWord.length >= 3
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      "
                      style="margin: 0 10px"
                      type="text"
                      @click="add_word(index)"
                      icon="el-icon-circle-plus"
                      circle
                    ></el-button>

                    <el-button
                      :disabled="form.keyWord.length <= 1"
                      :style="
                        form.keyWord.length <= 1
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      "
                      style=""
                      type="text"
                      @click="del_word(index)"
                      icon="el-icon-remove"
                      circle
                    ></el-button>
                  </div>
                </div>
                </el-form-item> -->
              <el-form-item label="标题">
                <div v-for="(item, index) in form.Casename" :key="index">
                  <div>
                    <el-select v-if="index > 0" class="sel" style="width: 80px; margin: 0 0px 10px 0" v-model="item.ties"
                      placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="word_s">
                    <el-input v-model="item.word" placeholder="请输入标题" clearable
                      style="width: calc(100% - 300px)"></el-input>

                    <el-button :disabled="form.Casename.length >= 2" :style="
                      form.Casename.length >= 2
                        ? 'color: #C0C4CC;'
                        : 'color: rgb(233, 191, 7);'
                    " style="margin: 0 10px" type="text" @click="add_word('Casename', index)"
                      icon="el-icon-circle-plus" circle></el-button>

                    <el-button :disabled="form.Casename.length <= 1" :style="
                      form.Casename.length <= 1
                        ? 'color: #C0C4CC;'
                        : 'color: rgb(233, 191, 7);'
                    " style="" type="text" @click="del_word('Casename', index)" icon="el-icon-remove"
                      circle></el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="全文">
                <div v-for="(item, index) in form.Content" :key="index">
                  <div>
                    <el-select v-if="index > 0" class="sel" style="width: 80px; margin: 0 0px 10px 0" v-model="item.ties"
                      placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="word_s">
                    <el-input v-model="item.word" placeholder="请输入全文" clearable
                      style="width: calc(100% - 300px)"></el-input>

                    <el-button :disabled="form.Content.length >= 2" :style="
                      form.Content.length >= 2
                        ? 'color: #C0C4CC;'
                        : 'color: rgb(233, 191, 7);'
                    " style="margin: 0 10px" type="text" @click="add_word('Content', index)"
                      icon="el-icon-circle-plus" circle></el-button>

                    <el-button :disabled="form.Content.length <= 1" :style="
                      form.Content.length <= 1
                        ? 'color: #C0C4CC;'
                        : 'color: rgb(233, 191, 7);'
                    " style="" type="text" @click="del_word('Content', index)" icon="el-icon-remove"
                      circle></el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="案由">
                <el-cascader style="
                      width: 100%;
                      margin: 0 0 10px 0;
                      width: calc(100% - 100px);
                    " v-model="form.Reason" :options="briefData" clearable :props="{
                      value: 'val',
                      label: 'name',
                      children: 'children',
                      multiple: true,
                      checkStrictly: true,
                    }" filterable popper-class="train-tree">
                </el-cascader>
                <!--  collapse-tags -->
              </el-form-item>
              <el-form-item label="当事人">
                <div class="word_s" v-for="(item, index) in form.Party" :key="index">
                  <el-select class="sel" style="width: 80px; margin: 0 10px 0px 0" v-model="item.type" placeholder="请选择">
                    <el-option v-for="item in options_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input v-model="item.name" placeholder="请输入当事人" clearable
                    style="width: calc(100% - 300px)"></el-input>
                  <el-button :disabled="form.Party.length >= 3" :style="
                    form.Party.length >= 3
                      ? 'color: #C0C4CC;'
                      : 'color: rgb(233, 191, 7);'
                  " style="margin: 0 10px" type="text" @click="add_parties(index)" icon="el-icon-circle-plus"
                    circle></el-button>

                  <el-button :disabled="form.Party.length <= 1" :style="
                    form.Party.length <= 1
                      ? 'color: #C0C4CC;'
                      : 'color: rgb(233, 191, 7);'
                  " style="" type="text" @click="del_parties(index)" icon="el-icon-remove" circle></el-button>
                </div>
              </el-form-item>
              <el-form-item label="文书类型">
                <div class="paper_s">
                  <el-button v-for="(item, index) in DocType" :key="index" :class="
                    form.DocType.indexOf(item.key) !== -1
                      ? 'yes_check'
                      : 'no_check'
                  " type="warning" size="mini" style="letter-spacing: 2px" @click="detail_search(item.key)">{{
  item.key }}</el-button>
                </div>
              </el-form-item>
              <el-form-item label="案号">
                <el-input style="
                      width: 100%;
                      margin: 0 0 10px 0;
                      width: calc(100% - 100px);
                    " v-model="form.CaseId" placeholder="请输入案号" clearable></el-input>
              </el-form-item>
              <el-form-item label="审理时间">
                <div class="word_s" style="display: flex; justify-content: none" v-for="(item, index) in form.RefereeDate"
                  :key="index">
                  <el-date-picker style="width: calc(45%)" v-model="item.time" format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                  <el-button :disabled="form.RefereeDate.length >= 3" :style="
                    form.RefereeDate.length >= 3
                      ? 'color: #C0C4CC;'
                      : 'color: rgb(233, 191, 7);'
                  " style="margin: 0 10px" type="text" @click="add_time(index)" icon="el-icon-circle-plus"
                    circle></el-button>

                  <el-button :disabled="form.RefereeDate.length <= 1" :style="
                    form.RefereeDate.length <= 1
                      ? 'color: #C0C4CC;'
                      : 'color: rgb(233, 191, 7);'
                  " style="" type="text" @click="del_time(index)" icon="el-icon-remove" circle></el-button>
                </div>
              </el-form-item>
              <el-form-item label="审理程序">
                <el-cascader style="width: calc(45% + 90px)" v-model="form.TrialPro" :options="trialtype" clearable
                  :props="{
                    value: 'key',
                    label: 'key',
                    children: 'children',
                    multiple: true,
                    checkStrictly: true,
                  }" filterable popper-class="train-tree">
                </el-cascader>
              </el-form-item>
              <el-form-item label="法院级别">
                <el-select style="width: calc(45% + 90px)" v-model="form.Leval" multiple filterable placeholder="请选择法院级别">
                  <el-option v-for="item in courtLevel" :key="item.value" :label="item.key" :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="审理法院">
                <div class="word_s" style="display: flex; justify-content: none">
                  <el-cascader class="sel" style="width: calc(45% + 90px)" v-model="form.Court" :options="court_"
                    clearable :props="{
                      value: 'name',
                      label: 'name',
                      children: 'children',
                      multiple: true,
                      checkStrictly: true,
                    }" filterable popper-class="train-tree">
                  </el-cascader>
                </div>
              </el-form-item>
              <el-form-item label="参照级别">
                <el-cascader class="sel" style="width: calc(45% + 90px)" v-model="form.Ref_level" :options="reference"
                  clearable :props="{
                    value: 'key',
                    label: 'key',
                    children: 'children',
                    multiple: true,
                    checkStrictly: true,
                  }" filterable popper-class="train-tree">
                </el-cascader>
              </el-form-item>
              <div></div>
              <el-form-item label="代理律所" style="width: 48%">
                <div class="lawFirms">
                  <div class="" v-for="(item, index) in form.Lawfirm" :key="index">
                    <div v-if="index > 0">
                      <el-select class="sel" style="width: 80px; margin: 0px 0 10px 0" v-model="item.ties"
                        placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="law_s">
                      <el-select class="sel" style="width: 80px; margin: 0 10px 0 0" v-model="item.type"
                        placeholder="请选择">
                        <el-option v-for="item in options_type" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-input v-model="item.name" placeholder="请输入代理律所" clearable
                        style="width: calc(100% - 195px)"></el-input>
                      <el-button :disabled="form.Lawfirm.length >= 2" :style="
                        form.Lawfirm.length >= 2
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      " style="margin: 0 10px" type="text" @click="add_firms(index)" icon="el-icon-circle-plus"
                        circle></el-button>

                      <el-button :disabled="form.Lawfirm.length <= 1" style="" :style="
                        form.Lawfirm.length <= 1
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      " type="text" @click="del_firms(index)" icon="el-icon-remove" circle></el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="代理律师" style="width: 48%">
                <div class="lawFirms">
                  <div class="" v-for="(item, index) in form.Lawer" :key="index">
                    <div v-if="index > 0">
                      <el-select class="sel" style="width: 100px; margin: 0px 0 10px 0" v-model="item.ties"
                        placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="law_s">
                      <el-select class="sel" style="width: 100px; margin: 0 10px 0 0" v-model="item.type"
                        placeholder="请选择">
                        <el-option v-for="item in options_type" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-input v-model="item.name" placeholder="请输入代理律师" clearable
                        style="width: calc(100% - 195px)"></el-input>
                      <el-button :disabled="form.Lawer.length >= 2" :style="
                        form.Lawer.length >= 2
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      " style="margin: 0 10px" type="text" @click="add_laws(index)" icon="el-icon-circle-plus"
                        circle></el-button>

                      <el-button :disabled="form.Lawer.length <= 1" :style="
                        form.Lawer.length <= 1
                          ? 'color: #C0C4CC;'
                          : 'color: rgb(233, 191, 7);'
                      " type="text" @click="del_laws(index)" icon="el-icon-remove" circle></el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item size="large" class="searchBtn" style="width: 100%">
                <el-button type="primary" @click="onSubmit"
                  style="background: rgb(250, 208, 93); color: white">开始检索</el-button>
                <el-button style="background: rgb(63, 27, 2); color: white" @click="resetForm()">重置条件</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import store from "@/store";

import ComFooter from "../../../components/ComFooter.vue";

export default {
  inject: ["reload"],

  data() {
    return {
      form: {

        Casename: [
          {
            ties: "and",

            word: "",
            type: 1,
          },
        ],
        Content: [
          {
            ties: "and",

            word: "",
            type: 1,
          },
        ],
        Reason: [],
        Party: [
          {
            // ties: "and",
            type: 1,
            name: "",
          },
        ],
        DocType: [], //文书类型
        CaseId: "", //案号
        RefereeDate: [
          {
            // ties: "and",
            time: [],
          },
        ],
        TrialPro: [], //审理程序
        Leval: [], //法院级别
        Court: [],
        Ref_level: [],
        Lawfirm: [
          {
            ties: "and",
            type: 1,
            name: "",
          },
        ],
        Lawer: [
          {
            ties: "and",
            type: 1,
            name: "",
          },
        ],
      },

      options: [
        {
          value: "and",
          label: "与",
        },
        {
          value: "or",
          label: "或",
        },
        {
          value: "not",
          label: "非",
        },
      ],
      options_tit: [
        {
          value: "Casename",
          label: "标题",
        },
        {
          value: "Content",
          label: "全文",
        },
        // {
        //   value: "CaseId",
        //   label: "案号",
        // },
      ],

      briefData: [],
      options_type: [
        {
          value: 1,
          label: "攻方",
        },
        {
          value: 2,
          label: "守方",
        },
      ],
      DocType: [],
      trialtype: [],
      courtLevel: [],
      court_: [],
      reference: [
        //参照级别
      ],
    };
  },
  computed: {},

  created() {
    this.visibles();
    this.caseList();
  },
  methods: {
    caseList() {
      this.$http
        .post("/category", {
          search: "[]",
          order: '{ field: "", type: "desc" }',
          page: 1,
          pageSize: 10,
        })
        .then((res) => {
          console.log(res);
          // console.log('a')
          let category = res.data.data.category;
          this.DocType = category.DocType;
          this.trialtype = category.TrialPro;
          this.courtLevel = category.Leval;
          this.court_ = category.court;
          this.reference = category.Ref_level;
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    //
    isObject(data) {
      return Object.prototype.toString.call(data) === "[object Object]";
    },
    // 高级检索
    onSubmit() {
      // console.log(this.form.Reason);
      const copy = { ...this.form };

      console.log(copy);
      // return
      let search = [];
      for (var i in copy) {
        // console.log(copy[i].constructor === Array)
        // return
        if (copy[i].constructor === Array) {
          if (copy[i].length > 0) {
            if (copy[i][0].constructor === Array) {
              let arr = [];
              copy[i].forEach((item, index) => {
                arr.push(item[item.length - 1]);
              });
              let copy_ = [i, arr];
              search.push(copy_);
            } else if (this.isObject(copy[i][0])) {
              if (copy[i][0].time) {
                let arr = [];
                copy[i].forEach((item, index) => {
                  if (item.time.length > 0) {
                    arr.push(item.time);
                  }
                });
                let copy_ = [i, arr];
                if (arr.length > 0) {
                  search.push(copy_);
                }
              } else if (copy[i][0].ties) {
                if (copy[i].length > 1) {
                  if (copy[i][1].ties == "or") {
                    copy[i][0].ties = "or"
                  }
                }
                let arr = [];
                copy[i].forEach((item, index) => {
                  if (item.name && item.name !== "") {
                    arr.push([item.ties, item.name, item.type]);
                  } else if (item.word && item.word !== "") {
                    arr.push([item.ties, item.word, item.type]);
                  }
                });
                let copy_ = [i, arr];
                if (arr.length > 0) {
                  search.push(copy_);
                }
              } else if (copy[i][0].name) {
                let arr = [];
                copy[i].forEach((item, index) => {
                  if (item.name !== '') {
                    arr.push([item.name, item.type]);
                  }

                });
                let copy_ = [i, arr];
                if (arr.length > 0) {
                  search.push(copy_);
                }

              }
            } else {
              let arr = [];
              if (copy[i].length > 0) {
                copy[i].forEach((item, index) => {
                  // console.log(item)
                  arr.push(item);
                });
                let copy_ = [i, arr];
                search.push(copy_);
              }

            }
          }
        } else {
          if (copy[i] !== "") {
            if (i == "CaseId") {
            let copy_ = ["CaseId", [["and", this.form.CaseId, 1]]]
            search.push(copy_);
          } else{
            let copy_ = [i, copy[i]];
            search.push(copy_);
          }

          }
        }
      }

      console.log(search);
      // return;
      window.localStorage.setItem("search_new", JSON.stringify(search));
      this.$router.push({ path: "/case" });
      window.localStorage.setItem("searchType", "1");
    },
    onSubmit_copy() {
      // console.log(this.form.Reason);
      const copy = { ...this.form };
      // 表单数据去空
      for (var i in copy) {
        if (copy[i].constructor === Array) {
          if (copy[i].length > 0) {
            copy[i].forEach((item, index) => {
              if (item.ties) {
                for (var j in item) {
                  if (item[j] == "") {
                    return delete copy[i];
                    Casename
                  }
                }
              }
            });
          } else {
            delete copy[i];
          }
        } else {
          // console.log(i);
          if (copy[i] == "") {
            delete copy[i];
          }
        }
      }
      // console.log(copy);
      // return
      // 表单数据重构传参
      let search = [];
      for (var i in copy) {
        if (copy[i].constructor === Array) {
          copy[i].forEach((item, index) => {
            console.log(i, item);
            if (item.ties) {
              if (item.tit) {
                if (item.tit == "Casename") {
                  let copy_ = [item.ties, item.tit, [item.word], item.type];
                  search.push(copy_);
                } else {
                  let copy_ = [item.ties, item.tit, item.word, item.type];
                  search.push(copy_);
                }
              } else if (item.type) {
                let copy_ = [item.ties, i, [item.type, item.name]];
                search.push(copy_);
              } else if (item.time) {
                let copy_ = ["and", i, item.time];
                search.push(copy_);
              } else {
                for (var j in item) {
                  console.log(item);
                  if (j !== "ties") {
                    if (item[j].constructor === Array) {
                      let copy_ = ["and", i, item[j][item[j].length - 1]];
                      search.push(copy_);
                    } else {
                      let copy_ = ["and", i, item];
                      search.push(copy_);
                    }
                    // let copy_ = [item.ties, i, item[j]];
                    // search.push(copy_);
                  }
                }
              }
            } else {
              console.log(item);
              if (item.constructor === Array) {
                let copy_ = ["and", i, item[item.length - 1]];
                search.push(copy_);
              } else {
                if (copy[i].length > 1) {
                  let copy_ = ["or", i, item];
                  search.push(copy_);
                } else {
                  let copy_ = ["and", i, item];
                  search.push(copy_);
                }
              }
            }
          });
        } else {
          console.log(i);
          if (i == "CaseId") {
            let copy_ =["CaseId", [["and", this.form.CaseId, 1]]]
            search.push(copy_);
          } else {
            let copy_ = ["and", i, copy[i]];
            search.push(copy_);
          }
        }
      }
      console.log(search);
      // console.log(JSON.stringify(search));
      // window.sessionStorage.setItem("search_new", JSON.stringify(search));
      // this.$router.push({ path: "/case" });
      // window.sessionStorage.setItem("searchType", "1");
    },
    // 重置  
    resetForm() {


      this.form = {
        keyWord: [
          {
            ties: "and",
            tit: "Casename",
            word: "",
            type: 1,
          },
        ],
        Casename: [
          {
            ties: "and",

            word: "",
            type: 1,
          },
        ],
        Content: [
          {
            ties: "and",

            word: "",
            type: 1,
          },
        ],
        Reason: [],
        Party: [
          {
            // ties: "and",
            type: 1,
            name: "",
          },
        ],
        DocType: [], //文书类型
        CaseId: "", //案号
        RefereeDate: [
          {
            // ties: "and",
            time: [],
          },
        ],
        TrialPro: [], //审理程序
        Leval: [], //法院级别
        Court: [
          {
            // ties: "and",
            court: [],
          },
        ],
        Ref_level: [],
        Lawfirm: [
          {
            ties: "and",
            type: 1,
            name: "",
          },
        ],
        Lawfirm: [
          {
            ties: "and",
            type: 1,
            name: "",
          },
        ],
        Lawer: [
          {
            ties: "and",
            type: 1,
            name: "",
          },
        ],
      };
      console.log(this.form)

    },
    toCase() {
      // window.sessionStorage.setItem("searchinput", "");
      window.sessionStorage.setItem("search-new", "[]");
      this.$router.push({ path: "/case" });
    },
    // 添加关键词检索条件
    add_word(type, i) {
      console.log(i);
      let word = {
        ties: "and",
        // tit: "Casename",
        word: "",
        type: 1,
      };
      this.form[type].splice(i + 1, 0, word);
    },

    // 删除关键词检索条件
    del_word(type, i) {
      this.form[type].splice(i, 1);
    },

    // 案由分类
    visibles() {
      // this.visible = (!this.visible)
      this.$http
        .get("/ay", {})
        .then((res) => {
          // console.log(res);
          this.briefData = res.data.data;
          this.briefData.forEach((item) => {
            if (item.children.length > 0) {
              item.children.forEach((itemTwo) => {
                if (itemTwo.children.length > 0) {
                  itemTwo.children.forEach((itemThree) => {
                    if (itemThree.children.length > 0) {
                      itemThree.children.forEach((itemFour) => {
                        if (itemFour.children.length > 0) {
                        } else {
                          this.$delete(itemFour, "children");
                        }
                      });
                    } else {
                      this.$delete(itemThree, "children");
                    }
                  });
                } else {
                  this.$delete(itemTwo, "children");
                }
              });
            } else {
              this.$delete(item, "children");
            }
          });
        })
        .catch((err) => { });
    },

    // 文书类型
    detail_search(val) {
      if (this.form.DocType.indexOf(val) == -1) {
        this.form.DocType.push(val);
      } else {
        this.form.DocType.splice(this.form.DocType.indexOf(val), 1);
      }
    },
    // 添加审理法院检索条件
    add_court(i) {
      let court = {
        // ties: "and",

        court: "",
      };
      this.form.Court.splice(i + 1, 0, court);
    },

    // 删除审理法院检索条件
    del_court(i) {
      this.form.Court.splice(i, 1);
    },

    // 添加代理律所检索条件
    add_firms(i) {
      let firms = {
        ties: "and",
        type: 1,
        name: "",
      };
      this.form.Lawfirm.splice(i + 1, 0, firms);
    },

    // 删除代理律所检索条件
    del_firms(i) {
      this.form.Lawfirm.splice(i, 1);
    },
    // 添加代理律师检索条件
    add_laws(i) {
      let law = {
        ties: "and",
        type: 1,
        name: "",
      };
      this.form.Lawer.splice(i + 1, 0, law);
    },

    // 删除代理律师检索条件
    del_laws(i) {
      this.form.Lawer.splice(i, 1);
    },

    // 添加当事人检索条件
    add_parties(i) {
      let law = {
        // ties: "and",
        type: 1,
        name: "",
      };
      this.form.Party.splice(i + 1, 0, law);
    },

    // 删除当事人检索条件
    del_parties(i) {
      this.form.Party.splice(i, 1);
    },
    // 添加审理时间检索条件
    add_time(i) {
      let time = {
        // ties: "and",
        time: [],
      };
      this.form.RefereeDate.splice(i + 1, 0, time);
    },

    // 删除审理时间检索条件
    del_time(i) {
      this.form.RefereeDate.splice(i, 1);
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style lang="less" scoped>
.background_box {
  // background: #f3ede3;
  background: rgb(245, 239, 228);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  // border-color: #dcdfe6 !important;
}

/deep/ .el-select .el-input__inner:focus {
  // border-color: #dcdfe6 !important;
}

/deep/ .el-input__inner {
  // border-color: #dcdfe6;
}

.box {
  width: 100%;
  background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // min-width: 1800px;
  // min-height: 1000px;
  // height: 100vh;
  // width: 100%;
  // min-width: 1280px;
  // max-width: 2000px;

  // margin: auto;
}

.case {
  width: 1280px;
  min-width: 1280px;
  max-width: 1280px;
  margin: auto;
  min-height: calc(100vh - 210px);

  // padding: 0 18%;
  // min-width: 1200px;
  .breadcrumb {
    margin: 20px 0;
  }

  .advanced_search {
    // margin-left: ;
    display: flex;
    justify-content: center;
    // border: 1px solid rgb(146, 146, 146);
    border-radius: 10px;
    margin: 0 0 10px 10px;
    padding: 20px 0 0 0;

    // background: white;
    /deep/ .el-input__inner {
      // background: #f7f1eb;
    }

    .carousel {
      padding: 20px 20px 20px 10px;
      border-radius: 10px;
      width: 20%;
      height: 150px;

      /deep/ .el-carousel__button {
        width: 10px;
      }

      .el-carousel__item h3 {
        display: inline-block;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        // line-height: 50px;
        margin: 0;

        span {
          display: inline-block;
        }
      }

      .el-carousel__item:nth-child(2n) {
        // background-color: #99a9bf;
        background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
        background-size: 100% 100%;
      }

      .el-carousel__item:nth-child(2n + 1) {
        // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
        background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
        background-size: 100% 100%;
      }
    }

    .el-tabs {
      width: 79%;

      .el-tab-pane {
        .el-popover {}

        .el-input {

          // height: 20px;
          /deep/ .el-input__inner {
            // border-radius: 0;
          }
        }

        .el-button {
          margin: 0;
          border: 0;
          // border-radius: 0;
        }
      }
    }

    /deep/ .el-popover--plain {
      margin-left: 700px;
    }
  }
}

// 高级检索下拉框
.advancedDown {
  display: flex;
  flex-wrap: wrap;

  /deep/ .el-form-item {
    margin: 0 10px 10px 0;
    // height: 28px;
    // width: 48%;
    width: 100%;

    .el-form-item__content {
      width: calc(100% - 120px);

      // margin-bottom: 20px;
      .el-input {
        // .el-input__inner {
        //   height: 28px;
        // }
      }
    }

    .el-button--primary {
      border-color: rgb(238, 198, 22);
    }
  }
}

.searchBtn {
  width: 100%;
  // height: 50px;
  display: flex;
  justify-content: center;

  /deep/.el-form-item__content {
    display: flex;
    justify-content: center;
    // margin-left: 50%;
    // margin: auto;
  }
}

/deep/ .el-icon-circle-plus {
  font-size: 30px !important;
  // color: rgb(233, 191, 7);
}

/deep/ .el-icon-remove {
  font-size: 30px !important;
  // color: rgb(233, 191, 7);
}

.word_s {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 0 10px 0;

  .el-button {
    padding: 0;
    margin: 0;
  }

  .sel {
    /deep/ .el-input__inner {
      text-align: center;
      background: white;
    }
  }

  /deep/ .el-input__inner {
    background: white;
  }
}

.paper_s {
  width: 100%;
  display: flex;
  margin: 5px 0 10px 0;

  // justify-content: space-between;
  .el-button {}

  .no_check {
    color: #e6a23c;
    // background: #fdf6ec;
    background: rgba(253, 246, 236, 0.2);
    border-color: #f5dab1;
  }

  .yes_check {
    color: #fff;
    background-color: #e6a23c;
    border-color: #e6a23c;
  }
}

.el-select-dropdown__item {
  text-align: center;
}
</style>
<style lang="less" >
// 级联选择器样式
.train-tree .el-cascader-node.is-selectable.in-active-path {
  color: #409eff;
  font-weight: 700;
  // background-color: #cdf7f8;
  // font-size: 14px;
  // font-family: PingFangSC-Regular, PingFang SC;
  // font-weight: 400;
  // color: #fff;
  // line-height: 20px;
  // border: none;
  // box-shadow: 5px 10px 12px 2px rgba(0, 0, 0, 0.27);
}

.train-tree .el-cascader-node.is-selectable.in-checked-path {
  // color: #b1ddee;

  // background-color: #cdf7f8;
  // font-size: 14px;
  // font-family: PingFangSC-Regular, PingFang SC;
  // font-weight: 400;
  // color: #fff;
  // line-height: 20px;
  // border: none;
  // box-shadow: 5px 10px 12px 2px rgba(0, 0, 0, 0.27);
}

.law_s {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 10px 0;

  .el-button {
    padding: 0;
    margin: 0;
  }
}
</style>

